/* global ADV */

import React from 'react';
import styled from 'styled-components';

const CashflowSummary = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  background: #fff;
  margin: 0;
  padding: 20px;
`;

const CashflowWrapper = styled.div`
  text-align: center;

  & + & {
    margin-left: 40px;
  }
`;

const CashflowTitle = styled.h5`
  opacity: 0.68;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.1px;
  color: #626661;
  text-transform: uppercase;
  margin: 0;
  margin-bottom: 0.8em;
  line-height: 1em;
  font-size: 12px;
`;

const CashflowAmount = styled.h1`
  font-size: 32px;
  font-weight: normal;
  letter-spacing: -0.3px;
  color: #626661;
  margin: 0;
  line-height: 1em;
  font-size: 28px;
`;

export default ({ income, expenses }) => (
  <CashflowSummary>
    <CashflowWrapper>
      <CashflowTitle>Income</CashflowTitle>
      <CashflowAmount>${ADV.util.formatValue(income, 'money')}</CashflowAmount>
    </CashflowWrapper>

    <CashflowWrapper>
      <CashflowTitle>Expenses</CashflowTitle>
      <CashflowAmount>${ADV.util.formatValue(expenses, 'money')}</CashflowAmount>
    </CashflowWrapper>
  </CashflowSummary>
);
